<script setup>
import AuthIframe from "./AuthIframe";
</script>

<template>
  <AuthIframe
    source="auth/forgot-password"
    use-v3-route
  />
</template>
